var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5039 14C16.7086 14 21 8.66353 21 7C21 5.32824 16.7008 0 10.5039 0C4.37661 0 0 5.32824 0 7C0 8.66353 4.37661 14 10.5039 14ZM10.5039 11.5871C8.08705 11.5871 6.17374 9.50353 6.16599 7C6.15824 4.43059 8.08705 2.41294 10.5039 2.41294C12.8975 2.41294 14.834 4.43059 14.834 7C14.834 9.50353 12.8975 11.5871 10.5039 11.5871ZM10.5039 8.65529C11.3637 8.65529 12.0764 7.90588 12.0764 7C12.0764 6.08588 11.3637 5.33647 10.5039 5.33647C9.6363 5.33647 8.92364 6.08588 8.92364 7C8.92364 7.90588 9.6363 8.65529 10.5039 8.65529Z",
    fill: "#8F8F8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.87dd8823655d1fb689415361d53f5b6a.svg";
export { ForwardRef as ReactComponent };